/* TODO: this can be moved to ember-intl config when ember-intl is updated to
   a V2 addon
   See https://github.com/ember-intl/ember-intl/releases/tag/v7.3.0 */

import type { Formats } from 'ember-intl';

export const formats: Formats = {
  'format-time': {
    hhmmss: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    },
  },
  'format-date': {
    hhmmss: {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    },
    dmy: {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    },
  },
  'format-number': {
    compact: { notation: 'compact' },
    EUR: {
      style: 'currency',
      currency: 'EUR',
    },
    USD: {
      style: 'currency',
      currency: 'USD',
    },
  },
};
